import * as types from './types';

function setTravelerInfo(data) {
    return {
        payload: data,
        type: types.SET_TRAVELER_INFO,
    };
}

function resetTravelerInfo() {
    return {
        type: types.RESET_TRAVELER_INFO,
    };
}

function setDepartTripId(tripId) {
    return {
        type: types.SET_DEPART_TRIP_ID,
        meta: tripId,
    };
}

function setReturnTripId(tripId) {
    return {
        type: types.SET_RETURN_TRIP_ID,
        meta: tripId,
    };
}

function removeTripIds() {
    return {
        type: types.REMOVE_TRIP_IDS,
    };
}

function setFareClass(data) {
    return {
        payload: data,
        type: types.SET_FARE_CLASS,
    };
}

export {
    removeTripIds,
    resetTravelerInfo,
    setDepartTripId,
    setFareClass,
    setReturnTripId,
    setTravelerInfo,
};
